<template lang="pug">
#page-top
  router-view
</template>

<script>
import '@/assets/css/sb-admin-2.min.css'
import '@/assets/vendor/fontawesome-free/css/all.min.css'
export default {
  name: 'Tutorials',
  components: {

  }
}
</script>
<style lang="scss" scoped>

</style>